// prettier-ignore
export const makettoDocumentRedirects = new Map([
	['Fundrise 1351 Form 1-A', '2739bf58-244d-408e-a50b-add9fc4dc2d2/fundrise-1351-1a-final.pdf'],
	['Fundrise 1351 Form U-7', 'b14febe4-aaf5-45e7-915d-a59ea2acb62e/fundrise-1351-u7-final.pdf'],
	['Fundrise 1351 Operating Agreement', '7b52d425-ae41-48d2-a784-8582d11491e4/Fundrise_1351_-_Fourth_Amended_and_Restated_Operating_Agreement.pdf'],
	['Fundrise 1351 Subscription Agreement', '0f3d85dd-564e-4b94-a288-c098e8011e6c/Fundrise_1351_H_Street_--_Subscription_Package.pdf']
]);
